import RequestManager from "./RequestManager";

const getAllSyncSessionsInDeployment = async (deploymentId, firstCursor, lastCursor, prev) => {
    const urlParams = "?ascending=false" + (prev ? "&cursor=" + firstCursor + "&prev=true" : lastCursor ? "&cursor=" + lastCursor : "");
    const sessions = await RequestManager.get({
        url: "/sync/deployment/v1/" + deploymentId + urlParams
    });
    return {
        ...sessions,
        ...sessions.data
    };
};

const getAllLogsInSession = async (sessionId) => {
    const logs = await RequestManager.get({
        url: "/sync/v1/" + sessionId
    });
    return logs;
};

const downloadLogs = async (deploymentId, startDate, endDate, details) => {
    const url = `/sync/download/v1/${deploymentId}/${startDate}/${endDate}` + (details ? `?details=${details}` : "");
    const response = await RequestManager.get({
        url
    });
    return response.data.url;
};

const Sync = {
    getAllSyncSessionsInDeployment,
    getAllLogsInSession,
    downloadLogs
};

export default Sync;